// src/utils/firestoreClean.ts
export function cleanForFirestore(input: any): any {
  // removes undefined, converts NaN/Infinity to null, preserves null/false/0/""/Date/Array
  if (input === undefined) return undefined;     // caller skips keys w/ undefined
  if (input === null) return null;
  if (typeof input === 'number') {
    if (Number.isNaN(input) || !Number.isFinite(input)) return null;
    return input;
  }
  if (typeof input === 'string' || typeof input === 'boolean') return input;
  if (input instanceof Date) return input;

  if (Array.isArray(input)) {
    const arr = input.map(v => cleanForFirestore(v)).filter(v => v !== undefined);
    return arr;
  }

  if (typeof input === 'object') {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(input)) {
      const cleaned = cleanForFirestore(v);
      if (cleaned !== undefined) out[k] = cleaned;
    }
    return out;
  }

  // functions, symbols, etc → drop
  return undefined;
}

/** shallow helper for updateDoc payloads */
export function stripUndefinedShallow<T extends Record<string, any>>(obj: T): Partial<T> {
  const out: Partial<T> = {};
  Object.keys(obj).forEach((k) => {
    const v = (obj as any)[k];
    if (v !== undefined) (out as any)[k] = v;
  });
  return out;
}